// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

export class HeaderNames {
    public static AuthKey: string = "Ocp-Apim-Subscription-Key";
    public static ConnectionId: string = "X-ConnectionId";
    public static ContentType: string = "Content-Type";
    public static CustomCommandsAppId: string = "X-CommandsAppId";
    public static Path: string = "Path";
    public static RequestId: string = "X-RequestId";
    public static RequestStreamId: string = "X-StreamId";
    public static RequestTimestamp: string = "X-Timestamp";
}
